/*
 * Hero showcase: the six product packs travel on a big coloured ring around the ad picture.
 * Every banner holds its own copy of the six chips; only the visible banner is moved. Packs on the far side of
 * the ring pass behind the picture (smaller, fainter), packs on the near side in front of it, so the motion reads
 * as a circle in depth. It holds while the mouse is on a pack, stops when the hero is off screen or the tab is
 * hidden, and stays still for people who prefer reduced motion. Nothing here is needed to use the hero.
 */
(function () {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const TAU = Math.PI * 2;

  function init(hero) {
    if (hero.dataset.hsReady) return;
    hero.dataset.hsReady = '1';
    const SPEED = TAU / 34000; // one turn in 34 s
    let angle = -Math.PI / 2, last = 0, raf = 0, onScreen = true, hold = false, slowness = 1;

    function place(slide) {
      const frame = slide.querySelector('.hs__frame'), chips = [...slide.querySelectorAll('.hs__chip')], track = slide.querySelector('.hs__track');
      if (!frame || !chips.length) return;
      const s = slide.getBoundingClientRect(), f = frame.getBoundingClientRect();
      if (!f.width) return;
      const small = innerWidth < 900, size = chips[0].offsetWidth || 96, edge = size * 0.6;
      // a big ellipse around the picture area: wide enough to reach the side backdrop, high enough to cross the picture
      // desktop: the picture fills the hero, so the ring keeps clear of the product bar at the bottom
      const cs = getComputedStyle(hero), top = f.top, bottom = f.bottom - (small ? 0 : parseFloat(cs.getPropertyValue('--dock')) || 0), h = bottom - top;
      const cx = f.left - s.left + f.width / 2, cy = top - s.top + h / 2;
      const rx = f.width / 2 - edge, ry = Math.min(h * (small ? 0.5 : 0.46), h / 2 - edge);
      if (track) { track.style.width = (rx * 2) + 'px'; track.style.height = (ry * 2) + 'px'; track.style.transform = `translate3d(${(cx - rx).toFixed(1)}px, ${(cy - ry).toFixed(1)}px, 0)`; }
      chips.forEach((chip, i) => {
        const a = angle + (i * TAU) / chips.length, sin = Math.sin(a), depth = (sin + 1) / 2; // 1 = nearest (bottom of the ring)
        const sc = 0.72 + 0.4 * depth, x = cx + rx * Math.cos(a) - size / 2, y = cy + ry * sin - size / 2;
        chip.style.transform = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0) scale(${(sc * (chip.classList.contains('is-self') ? 1.1 : 1)).toFixed(3)})`;
        chip.style.zIndex = sin > 0 ? 4 : 2;
        chip.style.opacity = (0.6 + 0.4 * depth).toFixed(2);
      });
    }
    const active = () => hero.querySelector('.hb__slide.is-active');
    function frameLoop(t) {
      raf = requestAnimationFrame(frameLoop);
      if (document.hidden || !onScreen) { last = t; return; }
      const dt = last ? Math.min(t - last, 64) : 16; last = t;
      slowness += ((hold ? 0 : 1) - slowness) * 0.08; // ease to a stop / back up to speed
      angle += SPEED * dt * slowness;
      const s = active(); if (s) place(s);
    }
    hero.addEventListener('pointerover', e => { if (e.target.closest && e.target.closest('.hs__chip')) hold = true; });
    hero.addEventListener('pointerout', e => { if (e.target.closest && e.target.closest('.hs__chip')) hold = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(es => { onScreen = es.some(e => e.isIntersecting); }, { threshold: 0 }).observe(hero);

    const settle = () => { const s = active(); if (s) place(s); };
    addEventListener('resize', settle);
    addEventListener('load', settle);
    document.addEventListener('shopify:section:load', settle);
    settle();
    if (reduce) return; // static ring
    raf = requestAnimationFrame(frameLoop);
  }

  document.querySelectorAll('[data-hs]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-hs]').forEach(init));
})();
